import { createRoot } from 'react-dom/client';

import App from './App';

(function () {
	const root = createRoot(document.getElementById('app'));
	root.render(<App />);
})();
